__webpack_require__.p = "/bellas-bytes-portfolio/";